<template>
  <div class="row">
    <!-- City and Address Update Modal -->
    <VueFinalModal
      v-model="showInfoModal"
      :esc-to-close="false"
      class="modal-container"
      content-class="modal-content2"
    >
      <div class="modal__content">
        <div class="row">
          <div class="col-12">
            <p class="text-center mb-4 titleYellowText">
              Completa tu Información
            </p>
            <p
              class="text-center mb-4"
              style="
                font-size: 14px;
                color: white;
                font-weight: bold;
                text-align: center;
                margin-bottom: 12px;
                line-height: 15px;
              "
            >
              Para procesar tu retiro, necesitamos conocer tu ciudad y dirección
            </p>

            <div class="form-group mb-3">
              <label style="color: white; font-weight: bold; margin-bottom: 8px"
                >Ciudad</label
              >
              <select
                class="form-control-purple"
                style="border: 2px solid #f9cc03; background: white"
                v-model="selectedCity"
                required
              >
                <option value="" disabled selected>Selecciona tu ciudad</option>
                <option v-for="city in sortedCities" :key="city" :value="city">
                  {{ city }}
                </option>
              </select>
            </div>

            <div class="form-group mb-3">
              <label style="color: white; font-weight: bold; margin-bottom: 8px"
                >Dirección</label
              >
              <textarea
                class="form-control-purple"
                style="
                  border: 2px solid #f9cc03;
                  background: white;
                  resize: vertical;
                  min-height: 80px;
                "
                v-model="selectedAddress"
                placeholder="Ingresa tu dirección completa (calle, número, sector, referencias)"
                required
              ></textarea>
            </div>

            <div class="text-center mt-4">
              <button
                id="btnUpdateInfoRetiro"
                type="button"
                class="btn btn-yellow-normal"
                :disabled="!selectedCity || !selectedAddress || isUpdatingInfo"
                @click="updateUserInfo"
              >
                Guardar Información
              </button>
            </div>
          </div>
        </div>
      </div>
    </VueFinalModal>

    <div class="col-lg-12 col-md-12 col-12 col-sm-12 col-xl-12" align="center">
      <h6
        style="font-size: 11px; margin-bottom: 20px; color: white"
        class="text-center"
      >
        Saldo disponible para retirar.
      </h6>
      <Skeletor
        v-if="loading"
        height="40"
        width="25%"
        style="margin-bottom: 20px; margin-top: 20px"
      />
      <h6
        v-else
        style="
          font-weight: bold;
          margin-bottom: 20px;
          margin-top: 20px;
          font-size: 40px;
        "
        class="text-center totalBalanceCard"
      >
        <span style="font-size: 25px">$</span>
        {{ Number(availableBalance).toFixed(2) }}
      </h6>
      <h6
        style="
          font-size: 11px;
          margin-bottom: 8px;
          line-height: 15px;
          color: white;
        "
        class="text-center"
      >
        El pago se realizará en máximo 5 días laborables.
      </h6>
      <h6
        style="
          font-size: 11px;
          margin-bottom: 8px;
          line-height: 15px;
          color: white;
        "
        class="text-center"
      >
        Valor mínimo de retiro: $20.00
      </h6>
      <h6
        style="
          font-size: 11px;
          margin-bottom: 8px;
          line-height: 15px;
          color: white;
        "
        class="text-center"
      >
        Puedes retirar tu saldo una vez completada tu primera venta
      </h6>

      <div class="col-lg-12 col-md-12 col-12 col-sm-12 col-xl-12 text-center">
        <!-- Show update info button if city or address is missing -->
        <button
          v-if="userBankAccountId && (!userCity || !userAddress)"
          class="btn btn-warning btn-sm"
          style="
            width: 100%;
            margin-top: 12px;
            background-color: #f9cc03;
            color: #7d0c7e;
            border: none;
            font-weight: bold;
          "
          type="button"
          @click="showUpdateInfoModal"
        >
          Actualizar información
        </button>
        <!-- Show withdraw button if all info is complete -->
        <button
          v-else-if="userBankAccountId && userCity && userAddress"
          class="btn btn-yellow-normal btn-sm"
          style="width: 100%; margin-top: 12px"
          :disabled="isDisabled"
          type="button"
          @click="withdrawBalance"
        >
          Retirar dinero
        </button>
        <!-- Show add bank account button if no bank account -->
        <router-link
          class="btn btn-primary btn-sm"
          style="width: 100%; display: inline-block; text-align: center"
          :to="'/dashboard/banco'"
          v-else
        >
          Agregar cuenta bancaria
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Saldo from "./Saldo.vue";
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";

export default {
  components: {
    Saldo,
    VueFinalModal,
  },
  props: ["userId", "tokenAuth", "closeWithdrawModal"],
  data() {
    return {
      isDisabled: true,
      loading: true,
      retiroCash: "",
      availableBalance: "0",
      // sales: 0,
      userBankAccountId: this.$store.state.user.userBankAccountId,
      showInfoModal: false,
      selectedCity: "",
      selectedAddress: "",
      isUpdatingInfo: false,
      userCity: this.$store.state.user.city,
      userAddress: this.$store.state.user.address,
      cities: [
        "Guayaquil",
        "Quito",
        "Cuenca",
        "Loja",
        "Santo Domingo",
        "Ambato",
        "Ibarra",
        "Portoviejo",
        "Riobamba",
        "Quevedo",
        "Latacunga",
        "Duran",
        "Pasaje",
        "Salinas",
        "La Libertad",
        "Azogues",
        "Manta",
        "Santa Rosa",
        "Babahoyo",
        "Tulcan",
        "Otavalo",
        "Montecristi",
        "Chone",
        "Cayambe",
        "Gualaceo",
        "Salcedo",
        "El Guabo",
        "Atuntaqui",
        "Huaquillas",
        "Piñas",
        "Cañar",
        "Machala",
        "Catamayo",
        "Jaramijo",
        "Cotacachi",
        "Arenillas",
        "Portovelo",
        "Calceta",
        "Alausi",
        "Tosagua",
        "Flavio Alfaro",
        "Camilo Ponce Enriquez",
        "Zaruma",
        "Balsas",
        "Chunchi",
        "Junin",
        "Cevallos",
        "Guamote",
        "Chaguarpamba",
      ],
    };
  },
  computed: {
    sortedCities() {
      return [...this.cities].sort((a, b) => a.localeCompare(b, "es"));
    },
  },
  watch: {},
  mounted() {
    this.$eventBus.on("reiniciarSaldos", () => {
      this.componentKeySaldos += 1;
    });
    this.fetchBalance();

    // Pre-fill existing data if available
    if (this.userCity) {
      this.selectedCity = this.userCity;
    }
    if (this.userAddress) {
      this.selectedAddress = this.userAddress;
    }
  },
  methods: {
    fetchBalance() {
      this.isDisabled = true;
      this.$https
        .get("/balances/me")
        .then((response) => {
          this.loading = false;
          this.availableBalance = response.data.balance.balanceTotal;
          // this.sales = response.data.balance.sales;
          if (response.data.balance.balanceTotal >= 20) {
            this.isDisabled = false;
          }
          // if (
          //   response.data.balance.balanceTotal >= 20 &&
          //   response.data.balance.sales > 0
          // ) {
          //   this.isDisabled = false;
          // }
        })
        .catch((error) => {
          if (error.status === 401) {
            this.$store.dispatch("clearAllData");
            this.$toast.error("Sesión expirada. Inicie sesión nuevamente", {
              position: "top-right",
              max: 10,
            });
            this.closeWithdrawModal();
            this.$router.push({ name: "Signin" });
          } else if (error.status === 404) {
            this.$toast.error("Saldo no encontrado", {
              position: "top-right",
              max: 10,
            });
            this.closeWithdrawModal();
          } else {
            this.$toast.error("Ocurrió un error inesperado", {
              position: "top-right",
              max: 10,
            });
            this.closeWithdrawModal();
          }
        });
    },

    withdrawBalance() {
      if (this.availableBalance === 0) {
        this.$toast.error("No existe dinero para retirar", {
          position: "top-right",
          max: 10,
        });
      } else {
        this.$swal({
          title: `¿Seguro que deseas hacer un retiro por $${parseFloat(
            this.availableBalance,
          ).toFixed(2)}?`,
          icon: "warning",
          width: "400px",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-secondary btn-outline-secondary ml-1",
          },
          buttonsStyling: false,
          showLoaderOnConfirm: true,
          preConfirm: () => {
            this.isDisabled = true;
            return this.$https
              .post(`/transactions/me/withdrawals`, {
                bankAccountId: this.userBankAccountId,
              })
              .then((response) => {
                return response;
              })
              .catch((error) => {
                // this.$swal.showValidationMessage(error);
                console.log("error", error);
              });
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
          backdrop: true,
        }).then((result) => {
          this.$swal.close();
          if (result.isConfirmed) {
            this.isDisabled = false;

            if (result.value.data.code == 200) {
              this.$toast.success(result.value.data.message, {
                position: "top-right",
                max: 10,
              });

              this.$eventBus.emit("closeModalRetiro");
              this.$eventBus.emit("reiniciarSaldos");
              this.isDisabled = false;
            } else if (result.value.data.code == 404) {
              this.$eventBus.emit("closeModalRetiro");
              this.$toast.error(result.value.data.message, {
                position: "top-right",
                max: 10,
              });
              this.isDisabled = false;
              if (
                result.value.data.message !==
                "Ya existe una solicitud pendiente de retiro"
              ) {
                this.$router.push({ name: "banco" });
              }
            } else {
              this.$toast.error(result.value.data.message, {
                position: "top-right",
                max: 10,
              });
              this.isDisabled = false;
            }
          }
        });
      }
    },

    showUpdateInfoModal() {
      this.showInfoModal = true;
    },

    updateUserInfo() {
      if (!this.selectedCity || !this.selectedAddress) return;

      this.isUpdatingInfo = true;
      document.getElementById("btnUpdateInfoRetiro").innerHTML =
        '<i class="fas fa-spinner fa-pulse"></i>  Guardando...';

      this.$https
        .patch("/profiles/me/address", {
          address: this.selectedAddress,
          city: this.selectedCity,
        })
        .then((response) => {
          this.$store.commit("setUser", response.data.updatedProfile);
          this.userCity = this.selectedCity;
          this.userAddress = this.selectedAddress;
          this.showInfoModal = false;
          this.$toast.success("Información actualizada exitosamente", {
            position: "top-right",
            max: 10,
          });
        })
        .catch((error) => {
          if (error.response?.data?.code === 401) {
            this.$store.dispatch("clearAllData");
            this.$toast.error("Sesión expirada. Inicie sesión nuevamente", {
              position: "top-right",
              max: 10,
            });
            this.closeWithdrawModal();
            this.$router.push({ name: "login" });
          } else {
            this.$toast.error("Error al actualizar la información", {
              position: "top-right",
              max: 10,
            });
          }
        })
        .finally(() => {
          this.isUpdatingInfo = false;
          document.getElementById("btnUpdateInfoRetiro").innerHTML =
            "Guardar Información";
        });
    },
  },
};
</script>

<style scoped>
.totalBalanceCard {
  background: rgb(168, 53, 153);
  background: linear-gradient(
    68deg,
    rgba(168, 53, 153, 1) 0%,
    rgba(222, 79, 217, 1) 100%
  );
  color: white;
  border: 2px solid #f65bf0;
  border-radius: 16px;
  padding: 3px 10px;
  width: fit-content;
}

.titleYellowText {
  text-align: center;
  font-family: Ubuntu;
  color: #7d0c7e;
  font-size: 14px;
  text-shadow:
    2px 2px 0px white,
    -2px -2px 0px white,
    2px -2px 0px white,
    -2px 2px 0px white;
  background: #f9cc03;
  border-radius: 12px;
  padding: 3px 12px;
  box-shadow: 0px 2px 10px 2px #7c0c7e48;
  width: fit-content;
  margin: 0 auto;
}
</style>
